/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM, themeStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TABLE : COLUMN : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	column: {
		// see table_styles for more (variants can alter styles)
		position: 'relative',
		zIndex: '1',
		transition: 'all .2s linear 0s',

		// ----- align ----- //
		'&.align-left': { textAlign: 'left' },
		'&.align-center': { textAlign: 'center' },
		'&.align-right': { textAlign: 'right' }
	}
});